import { useState, useCallback } from "react";
import { useDebounceFunction as useDebounce } from "hooks/useDebounce";

export const useTextInput = (defaultValue: string, setter: (value: string) => void, debounce = 400) => {
    const [value, setValue] = useState(defaultValue);
    const setValueDebounce = useDebounce(setter, debounce);

    const handleChange = useCallback(
        (e: Event | string, value: string = e as string) => {
            setValue(value);
            setValueDebounce(value);
        },
        [setValueDebounce]
    );
    return [value, handleChange];
};
